<template>
    <div>
        <el-dialog title="添加日志" width: :visible.sync="insertrecordflag">
            <avue-form v-model="formobj" :option="option" @submit="submit" @reset-change="emptytChange" :upload-after="uploadAfter">
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
    import {insertrecord} from '@/api/admin/taskManagement'
    import { objKeySort } from '@/util/ajaxsign'
    import {getImgLink,getImgLinksplit} from '@/config/env'
    import {dealElement} from '@/util/util'
    export default {
        components: {},
        data() {
            return {
                insertrecordflag : false,
                projectId : '',
                radiorecord : '',
                formobj : {
                    tips : '',
                    imgPaths : [],
                    videoPaths : [],
                },
               
                option : {
                    emptyBtn:true,
                    submitBtn:true,
                    emptyText : '取消',
                    column: [{
                        label: "反馈描述",
                        prop: "tips",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请输入反馈描述",
                            trigger: "blur"
                        }]
                    },{
                        label: '添加图片',
                        prop: 'imgPaths',
                        type: 'upload',
                        limit: 9,
                        span: 24,
                        listType: 'picture',
                        action: '/files/fileUpload'
                    },{
                        label: '添加视频',
                        prop: 'videoPaths',
                        type: 'upload',
                        limit: 3,
                        span: 24,
                        listType: 'picture',
                        action: '/files/fileUpload'
                    }]
                }
            }
        },
        created() {},
       
        methods: {
            //设置展示
             insertstate(projectId){
                this.projectId = projectId;
                this.insertrecordflag = true;
                this.form.imglist.length=0;
            },

            //上传后的方法
            uploadAfter(res, done,loading) {
                done()
                //fileName
                //判断是视频换上图片
                if(res.data.data.fileName.split('.')[1] == 'jpg' || res.data.data.fileName.split('.')[1] == 'png'){
                    this.formobj.imgPaths.push({"label" : '反馈图片',"value" : getImgLink(res.data.data.filePath)});
                    for(var i=0;i<this.formobj.imgPaths.length;i++){
                        if (this.formobj.imgPaths[i].value === undefined) this.formobj.imgPaths.splice(i, 1);
                    }
                }else{
                    this.formobj.videoPaths.push({"label" : '反馈视频',"value" : getImgLink(res.data.data.filePath)});
                    for(let i=0;i<this.formobj.videoPaths.length;i++){
                        if (this.formobj.videoPaths[i].value === undefined) this.formobj.videoPaths.splice(i, 1);
                    }
                }
            },

            //添加日志
            submit () {
                insertrecord(objKeySort(this.setrecord())).then(response =>{
                    this.emptytChange();
                    this.$emit('refresh');
                    this.$emit('refresh');
                    this.formobj.tips = '';
                    this.formobj.imgPaths = [];
                    this.formobj.videoPaths = [];
                })
            },

            //日志数据处理
            setrecord(){
                let imgs = new Array(),video = new Array();
                for(let i=0;i<this.formobj.imgPaths.length;i++){
                    imgs.push(getImgLinksplit(this.formobj.imgPaths[i].value))
                }
                for(let j=0;j<this.formobj.videoPaths.length;j++){
                    video.push(getImgLinksplit(this.formobj.videoPaths[j].value))
                }
                var adddata = {
                    "tips" : this.formobj.tips,
                    "projectId" : this.projectId,
                    "imgPaths" : JSON.stringify(imgs.join(',')).replace(/\"/g, ""),
                    "videoPaths" : JSON.stringify(video.join(',')).replace(/\"/g, "")
                }
                return dealElement(adddata);
            },

            //去消操作
            emptytChange(){
                this.insertrecordflag = false;
            },
            
        }
    }
</script>
<style lang="scss" scoped>
    .avue-crud-upload ul li{
        width: 90px;
        float: left;
        margin: 0 15px 15px 0;
    }
</style>